import React from "react";
import arrow from "../../../assets/images/home/01-hero/button-arrow.svg";
import "./OcButton.scss";

/**
 * Pill button from the OC Minds design system.
 * variant: "primary" (filled blue) | "outline" (white w/ blue border)
 */
export default function OcButton({
  children,
  variant = "primary",
  href,
  onClick,
  target,
  showArrow = true,
  className = "",
  ...rest
}) {
  const cls = `oc-btn oc-btn--${variant} ${className}`.trim();
  const content = (
    <>
      <span className="oc-btn__label">{children}</span>
      {showArrow && <img className="oc-btn__arrow" src={arrow} alt="" aria-hidden="true" />}
    </>
  );

  if (href) {
    return (
      <a className={cls} href={href} target={target} rel={target === "_blank" ? "noopener noreferrer" : undefined} onClick={onClick} {...rest}>
        {content}
      </a>
    );
  }
  return (
    <button type="button" className={cls} onClick={onClick} {...rest}>
      {content}
    </button>
  );
}
